import { kebabCase } from 'lodash'

export default function slugify(string: string) {
  return kebabCase(string)
}
